import { render, staticRenderFns } from "./listing-facts-list.vue?vue&type=template&id=38602e96&scoped=true"
import script from "./listing-facts-list.vue?vue&type=script&setup=true&lang=js"
export * from "./listing-facts-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./listing-facts-list.vue?vue&type=style&index=0&id=38602e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38602e96",
  null
  
)

export default component.exports